import { PAYMENT_MODULE } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
type ICartAPIResponse = { status: boolean; message: string };
export interface ICreditNoteResponseData {
  user_id: string;
  invoice_id: string;
  mode: string;
  credit_note_type: string;
  credit_amount: number;
  credit_reason: string;
  notes: string;
  clinic_id: string;
  clinic_name: string;
  credit_note_receipt_id: string;
  created_by: string;
  created_at: number;
  total_debit_amount: number;
}

export const usePaymentRefundRequestApprovalDetailsAPI = () => {
  const configuration = useConfiguration();
  const [refundApprovalData, setRefundApprovalData] = useState<any>(null);
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  // isCustomerWalletTableInProgress
  const execute = useCallback(
    async (creditNoteId: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: ICartAPIResponse = await axios
          .get(`${PAYMENT_MODULE?.SINGLE_REFUND_REQUESTED_NOTE?.baseURL}?refund_request_id=${creditNoteId}`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<any>) => {
            if (res.data.status === true) {
              setRefundApprovalData(res.data.data);

              return { status: true, message: "Cart Level Coupons Fetched" };
            } else {
              setRefundApprovalData(null);

              return { status: false, message: "No Cart Level Coupons" };
            }
          })
          .catch((e: AxiosError) => {
            setRefundApprovalData(null);
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            return { status: false, message: "cart_not_filtered" };
          });
        return response;
      } catch (e: any) {
        setRefundApprovalData(null);
        captureError(e);
      }
    },
    [dispatch],
  );
  return { refundApprovalData, execute };
};
